module.exports = __webpack_public_path__ + "static/media/promotion-banner-desktop.2c43ec8b.png";